
/** Here we could use a single stream of integer taking a value from 4 constants or 4 streams each having just true/false or state/undefined - up to the choice.
 * */
export default function(
    $preview,
    $startRotate,
    $play,
    $jackpot,
    $hide,
    view
)
{
    $preview.subscribe( state => view.fallDown( data( state ) ) );  // рулетка выпала
    $startRotate.subscribe( () => view.startRotate() );             // запуск вращения колеса рулетки
    $play.subscribe( state => view.play( data( state ) ) );         // отображение исхода
    
    $hide.subscribe( () => view.hide() );
    
    $jackpot
        //if no "bonusTypeId" then it's jackpot on it's own (without precursing roulette):
        .filter( state => state.state.stage.math.bonusTypeId )
        .subscribe( state => view.onFinishState( data( state ) ) );
    
    return {
        $animating : view.space.s( "animating" ).distinctUntilChanged(),
        $startImpulse : view.space.s( "start" ),
    };
}

function data( state )
{
    const mult = state.state.multiplier;
    const winTable = state.state.stage.math.winTable || {};
    
    const result = {
        megaJackpotWin : winTable[ 4 ] * mult,
        superJackpotWin : winTable[ 3 ] * mult,
        jackpotWin : winTable[ 2 ] * mult,
        result : state.state.stage.math.bonusTypeId,
        lifeTime : state.state.stage.math.lifeTime,
    };
    
    return result;
}



// WEBPACK FOOTER //
// ./src/library/bonus_roulette.es6